module.exports = __webpack_public_path__ + "static/media/icon2.54e3b606.jpg";